import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'video-react/dist/video-react.css';
import 'dashjs/dist/dash.all.min.js';
import React, { useRef, useEffect } from 'react';
import { chakra, useStyleConfig, Box } from '@chakra-ui/react';
import dashjs from 'dashjs';
import Hls from 'hls.js';
import { VolumeMenuButton as VolumeMenuButton$1, PlayToggle as PlayToggle$1, ClosedCaptionButton as ClosedCaptionButton$1, CurrentTimeDisplay as CurrentTimeDisplay$1, TimeDivider as TimeDivider$1, DurationDisplay as DurationDisplay$1, ProgressControl as ProgressControl$1, FullscreenToggle as FullscreenToggle$1, Player, BigPlayButton, ControlBar } from 'video-react';
import { videoPlayerSx } from './styles.js';
var _excluded = ["src", "type", "closedCaptions"];
var VolumeMenuButton = chakra(VolumeMenuButton$1);
var PlayToggle = chakra(PlayToggle$1);
var ClosedCaptionButton = chakra(ClosedCaptionButton$1);
var CurrentTimeDisplay = chakra(CurrentTimeDisplay$1);
var TimeDivider = chakra(TimeDivider$1);
var DurationDisplay = chakra(DurationDisplay$1);
var ProgressControl = chakra(ProgressControl$1);
var FullscreenToggle = chakra(FullscreenToggle$1);
var VideoPlayer = function VideoPlayer(_ref) {
  var src = _ref.src,
    type = _ref.type,
    closedCaptions = _ref.closedCaptions,
    rest = _objectWithoutProperties(_ref, _excluded);
  var videoRef = useRef();
  /**
   * Hooks
   */
  var styles = useStyleConfig('VideoPlayer', {});
  useEffect(function () {
    var _videoRef$current;
    var video = (_videoRef$current = videoRef.current) === null || _videoRef$current === undefined ? undefined : _videoRef$current.video.video;
    if (!video || !src) {
      return;
    }
    //using dash.js
    if (type === 'application/dash+xml') {
      var player = dashjs.MediaPlayer().create();
      player.initialize(video, src, true);
      return function () {
        player.reset();
      };
    } else if (type === 'application/x-mpegURL') {
      if (video !== null && video !== undefined && video.canPlayType('application/vnd.apple.mpegurl')) {
        video.addEventListener('loadedmetadata', function () {
          video === null || video === undefined || video.play();
        });
      } else if (Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          hls.startLoad();
        });
      }
    }
  }, []);
  if (!src) {
    return null;
  }

  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(Box, {
    "data-object-type": "core-video-player",
    __css: styles,
    sx: videoPlayerSx
  }, /*#__PURE__*/React.createElement(Player, _extends({
    ref: videoRef
  }, rest), /*#__PURE__*/React.createElement("source", {
    src: src,
    type: type
  }), /*#__PURE__*/React.createElement(BigPlayButton, {
    position: "center"
  }), (closedCaptions !== null && closedCaptions !== undefined ? closedCaptions : []).map(function (caption, index) {
    return /*#__PURE__*/React.createElement("track", {
      key: "".concat(caption.locale.key, "-caption"),
      kind: "captions",
      src: caption.path,
      srcLang: caption.locale.key,
      label: caption.locale.title,
      "default": index == 0
    });
  }), /*#__PURE__*/React.createElement(ControlBar, {
    disableDefaultControls: true,
    autoHide: false
  }, /*#__PURE__*/React.createElement(PlayToggle, {
    __css: styles.playToggle,
    order: 7.1
  }), /*#__PURE__*/React.createElement(CurrentTimeDisplay, {
    __css: styles.timeDisplay,
    order: 7.2
  }), /*#__PURE__*/React.createElement(TimeDivider, {
    __css: styles.timeDisplay,
    order: 7.3,
    separator: "/"
  }), /*#__PURE__*/React.createElement(DurationDisplay, {
    __css: styles.timeDisplay,
    order: 7.4
  }), /*#__PURE__*/React.createElement(ProgressControl, {
    __css: styles.progressControl,
    order: 7.5
  }), /*#__PURE__*/React.createElement(VolumeMenuButton, {
    __css: styles.volumeButton,
    vertical: true,
    order: 7.6
  }), /*#__PURE__*/React.createElement(ClosedCaptionButton, {
    order: 7.7,
    __css: styles.closedCaptionButton
  }), /*#__PURE__*/React.createElement(FullscreenToggle, {
    actions: {},
    order: 7.8,
    __css: styles.fullscreenToggle
  }))));
};
VideoPlayer.displayName = "VideoPlayer";
export { VideoPlayer };